<template>
    <AppLayout>
        <div class="col-12 layout-spacing">
            <div class="widget widget-six">
                <div class="widget-heading">
                    <div class="row">
                        <div class="col-12 d-inline-flex align-items-center">
                            <h4 class="me-3 my-0">Phishing - testy</h4>
                            <button @click="openModal" class="btn btn-primary btn-sm"><i
                                    class="bi bi-plus-circle me-2"></i>Dodaj</button>
                        </div>
                    </div>
                </div>
                <div class="widget-content">
                    <div class="custom-table">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Tytuł</th>
                                        <th>Utworzył</th>
                                        <th>Status</th>
                                        <th>Wysłano do</th>
                                        <th>Opcje</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(scamtest, index) in scamtestLocal" :key="index">
                                        <td>{{ scamtest.id }}</td>
                                        <td>{{ scamtest.title }}</td>
                                        <td>{{ scamtest.creator?.name || '' }}<br>{{ formatDate(scamtest.created_at) }}
                                        </td>
                                        <td>{{ scamtest.active === 1 ? 'Aktywne' : 'Zarchiwizowane' }}</td>
                                        <td>
                                            <span v-if="scamtest.send_to !== null && scamtest.send_to !== undefined"
                                                class="badge bg-success">
                                                {{ scamtest.send_to }}
                                            </span>
                                            <span v-else class="badge bg-secondary">
                                                Nie wysłano
                                            </span>
                                        </td>
                                        <td>
                                            <button v-if="scamtest.send_to !== null && scamtest.send_to !== undefined"
                                                @click="openWyniki(scamtest)" class="btn btn-sm btn-info me-2 mb-2"><i
                                                    class="bi bi-info me-2"></i>Wyniki</button>
                                            <button v-if="scamtest.active == 1" @click="sendtest(scamtest)"
                                                class="btn btn-sm btn-outline-primary me-2 mb-2"><i
                                                    class="bi bi-envelope me-2"></i>Wyślij do siebie</button>
                                            <button v-if="scamtest.active == 1" @click="sendSCAM(scamtest)"
                                                class="btn btn-sm btn-outline-success me-2 mb-2"><i
                                                    class="bi bi-envelope me-2"></i>Wyślij</button>
                                            <button @click="editSCAM(scamtest)"
                                                class="btn btn-sm btn-outline-info me-2 mb-2"><i
                                                    class="bi bi-pencil me-2"></i>Edytuj</button>
                                            <button @click="deleteSCAM(scamtest.id)"
                                                class="btn btn-sm btn-danger me-2 mb-2"><i
                                                    class="bi bi-trash me-2"></i>Usuń</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Nowa informacja</h5>
                                    <button type="button" class="btn-close" @click="closeModal"></button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label class="form-label" for="title">Tytuł wiadomości:</label>
                                            <input id="title" v-model="newSCAM.title" class="form-control" />
                                        </div>
                                        <div class="col-md-12"><br>
                                            <label>Adres do dla linków w wiadomościach:</label>
                                            <div>https://erp.askla.pl/mailer/send?who=[user_id]&what=[scam_id]</div>
                                            <HtmlOrRichTextEditor class="mt-2" id="editorDescription"
                                                label="Treść wiadomości" modelName="description"
                                                v-model="newSCAM.description" />
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label" for="from_email">Nadawca email: <span
                                                    class="text-danger">*</span></label>
                                            <input id="from_email" v-model="newSCAM.from_email" type="email"
                                                class="form-control" :class="{ 'is-invalid': formErrors.from_email }" />
                                            <div v-if="formErrors.from_email" class="invalid-feedback">
                                                {{ formErrors.from_email }}
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <label class="form-label" for="from_name">Nadawca nazwa: <span
                                                    class="text-danger">*</span></label>
                                            <input id="from_name" v-model="newSCAM.from_name" class="form-control"
                                                :class="{ 'is-invalid': formErrors.from_name }" />
                                            <div v-if="formErrors.from_name" class="invalid-feedback">
                                                {{ formErrors.from_name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" @click="closeModal">Anuluj</button>
                                    <button class="btn btn-primary" @click="saveNewSCAM">Zapisz</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isEditModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Edycja informacji</h5>
                                    <button type="button" class="btn-close" @click="closeEditModal"></button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label class="form-label" for="title">Tytuł wiadomości:</label>
                                            <input id="title" v-model="editedSCAM.title" class="form-control" />
                                        </div>
                                        <div class="col-md-12"><br>
                                            <label>Adres do dla linków w wiadomościach:</label>
                                            <div>https://erp.askla.pl/mailer/send?who=[user_id]&what=[scam_id]</div>
                                            <HtmlOrRichTextEditor class="mt-2" id="editorDescriptionEdit"
                                                label="Treść wiadomości" modelName="description"
                                                v-model="editedSCAM.description" />
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label" for="edit_from_email">
                                                Nadawca email: <span class="text-danger">*</span>
                                            </label>
                                            <input id="edit_from_email" v-model="editedSCAM.from_email" type="email"
                                                class="form-control"
                                                :class="{ 'is-invalid': editFormErrors.from_email }" />
                                            <div v-if="editFormErrors.from_email" class="invalid-feedback">
                                                {{ editFormErrors.from_email }}
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <label class="form-label" for="edit_from_name">
                                                Nadawca nazwa: <span class="text-danger">*</span>
                                            </label>
                                            <input id="edit_from_name" v-model="editedSCAM.from_name"
                                                class="form-control"
                                                :class="{ 'is-invalid': editFormErrors.from_name }" />
                                            <div v-if="editFormErrors.from_name" class="invalid-feedback">
                                                {{ editFormErrors.from_name }}
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label" for="active">Status:</label>
                                            <select id="active" v-model="editedSCAM.active" class="form-select">
                                                <option value="0">Zarchiwizowana</option>
                                                <option value="1">Aktywna</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" @click="closeEditModal">Anuluj</button>
                                    <button class="btn btn-primary" @click="updateSCAM(editedSCAM)">Zapisz</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isWynikiModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Wyniki testu <span v-if="wynikiSCAM.id">#{{ wynikiSCAM.id
                                            }}</span></h5>
                                    <button type="button" class="btn-close" @click="closeWynikiModal"></button>
                                </div>
                                <div class="modal-body">
                                    <div v-if="wynikiLoading" class="text-center py-4">
                                        <div class="spinner-border" role="status">
                                            <span class="visually-hidden">Ładowanie...</span>
                                        </div>
                                    </div>
                                    <div v-else-if="wyniki.length === 0" class="alert alert-info">
                                        Brak wyników dla tego testu.
                                    </div>
                                    <div v-else class="row">
                                        <div class="col-md-6">
                                            <table class="table table-bordered table-hover align-middle">
                                                <thead>
                                                    <tr>
                                                        <th class="text-success">Osoby które nie klikły</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="wynik in wyniki.filter(w => Number(w.user_click) === 0)"
                                                        :key="wynik.id">
                                                        <td>{{ wynik.reciver?.first_name }} {{ wynik.reciver?.last_name
                                                            }}</td>
                                                    </tr>
                                                    <tr
                                                        v-if="wyniki.filter(w => Number(w.user_click) === 0).length === 0">
                                                        <td class="text-muted text-center">Brak osób</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-md-6">
                                            <table class="table table-bordered table-hover align-middle">
                                                <thead>
                                                    <tr>
                                                        <th class="text-danger">Osoby które klikły</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="wynik in wyniki.filter(w => Number(w.user_click) === 1)"
                                                        :key="wynik.id">
                                                        <td>{{ wynik.reciver?.first_name }} {{ wynik.reciver?.last_name
                                                            }}</td>
                                                    </tr>
                                                    <tr
                                                        v-if="wyniki.filter(w => Number(w.user_click) === 1).length === 0">
                                                        <td class="text-muted text-center">Brak osób</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger"
                                        @click="closeWynikiModal">Zamknij</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isSendUsersModalOpen" class="modal fade show" tabindex="-1"
                        style="display: block; background: rgba(0,0,0,.5);">
                        <div class="modal-dialog modal-lg modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">
                                        Wybierz odbiorców
                                    </h5>
                                    <button type="button" class="btn-close" @click="closeSendUsersModal">
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="d-flex justify-content-between align-items-center mb-3">
                                        <div>
                                            <strong>
                                                {{ wynikiSCAM.title }}
                                            </strong>
                                        </div>
                                        <div>
                                            Wybrano:
                                            <strong>{{ selectedUsers.length }}</strong>
                                            / {{ users.length }}
                                        </div>
                                    </div>

                                    <div class="select-all-wrapper mb-3 p-3 border rounded">
                                        <label for="toggleAll" class="select-all-label">
                                            <input id="toggleAll" type="checkbox" class="user-checkbox"
                                                v-model="selectAllUsers" @change="toggleSelectAllUsers">

                                            <span>Zaznacz wszystkich</span>
                                        </label>
                                    </div>
                                    <div class="table-responsive" style="max-height: 450px; overflow-y: auto;">
                                        <table class="table table-hover table-bordered align-middle">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;"></th>
                                                    <th>Nazwisko</th>
                                                    <th>Imię</th>
                                                    <th>Email</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="user in [...users].sort((a, b) => {
                                                    const nazwiskoA = (a.last_name || '').toLowerCase();
                                                    const nazwiskoB = (b.last_name || '').toLowerCase();
                                                    return nazwiskoA.localeCompare(nazwiskoB, 'pl');
                                                })" :key="user.id" @click="toggleUser(user.id)"
                                                    style="cursor: pointer;">
                                                    <td>
                                                        <input type="checkbox" class="user-checkbox"
                                                            :checked="selectedUsers.includes(user.id)" @click.stop
                                                            @change="toggleUser(user.id)">
                                                    </td>
                                                    <td>
                                                        {{ user.last_name }}
                                                    </td>
                                                    <td>
                                                        {{ user.first_name }}
                                                    </td>
                                                    <td>
                                                        {{ user.email }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" @click="closeSendUsersModal">
                                        Anuluj
                                    </button>
                                    <button type="button" class="btn btn-success" :disabled="selectedUsers.length === 0"
                                        @click="confirmSendSCAM">
                                        <i class="bi bi-envelope me-2"></i>
                                        Wyślij do {{ selectedUsers.length }} osób
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import HtmlOrRichTextEditor from "@/Pages/Admin/parts/HtmlOrRichTextEditor.vue";

const { hasPermission } = usePermission();

export default {
    components: { AppLayout, HtmlOrRichTextEditor },
    props: {
        scamtest: Array,
        users: Array,
    },
    data() {
        return {
            hasPermission,
            editingId: null,
            addingNew: false,
            newSCAM: this.getEmptyForm(),
            editedSCAM: {},
            isModalOpen: false,
            isEditModalOpen: false,
            isWynikiModalOpen: false,
            wynikiSCAM: {},
            wyniki: [],
            wynikiLoading: false,
            scamtestLocal: [],
            selectedUsers: [],
            selectAllUsers: false,
            isSendUsersModalOpen: false,
            editFormErrors: {
                from_email: '',
                from_name: ''
            },
            formErrors: {
                from_email: '',
                from_name: ''
            }
        };
    },

    mounted() {
        this.scamtestLocal = this.scamtest.map(t => ({ ...t }));
    },
    methods: {

        formatDate(timestamp) {
            if (!timestamp) return '';
            const date = new Date(timestamp);
            return date.toISOString().split('T')[0];
        },
        toggleSelectAllUsers() {
            if (this.selectAllUsers) {
                this.selectedUsers = this.users.map(user => user.id);
            } else {
                this.selectedUsers = [];
            }
        },

        toggleUser(userId) {
            if (this.selectedUsers.includes(userId)) {
                this.selectedUsers = this.selectedUsers.filter(id => id !== userId);
            } else {
                this.selectedUsers.push(userId);
            }

            this.selectAllUsers =
                this.selectedUsers.length === this.users.length;
        },

        closeSendUsersModal() {
            this.isSendUsersModalOpen = false;
            this.selectedUsers = [];
            this.selectAllUsers = false;
        },

        confirmSendSCAM() {
            if (this.selectedUsers.length === 0) {
                Toast.fire({
                    toast: true,
                    icon: 'warning',
                    title: 'Nie wybrano odbiorców',
                    position: 'top-end',
                    timer: 3000,
                    showConfirmButton: false
                });

                return;
            }

            const selectedCount = this.selectedUsers.length;

            this.$inertia.post(
                route('admin.phising.send-mail', this.wynikiSCAM.id),
                {
                    user_ids: this.selectedUsers
                },
                {
                    preserveScroll: true,

                    onSuccess: () => {
                        this.closeSendUsersModal();

                        Toast.fire({
                            toast: true,
                            icon: 'success',
                            title: 'Wysyłanie zakończone',
                            html: `Wiadomości zostały wysłane do ${selectedCount} odbiorców.`,
                            position: 'top-end',
                            timer: 3000,
                            showConfirmButton: false
                        });

                        this.$inertia.reload({
                            only: ['scamtest'],
                            preserveScroll: true,

                            onSuccess: (page) => {
                                this.scamtestLocal = page.props.scamtest.map(item => ({
                                    ...item
                                }));
                            }
                        });
                    },

                    onError: () => {
                        Toast.fire({
                            toast: true,
                            icon: 'error',
                            title: 'Nie udało się wysłać wiadomości',
                            position: 'top-end',
                            timer: 4000,
                            showConfirmButton: false
                        });
                    }
                }
            );
        },
        async openModal() {
            this.formErrors = {
                from_email: '',
                from_name: ''
            };
            this.isModalOpen = true;
        },

        closeModal() {
            this.isModalOpen = false;
            this.newSCAM = this.getEmptyForm();
            this.formErrors = {
                from_email: '',
                from_name: ''
            };
        },

        closeEditModal() {
            this.isEditModalOpen = false;
        },
        closeWynikiModal() {
            this.isWynikiModalOpen = false;
            this.wynikiSCAM = {};
            this.wyniki = [];
        },
        getEmptyForm() {
            return {
                id: null,
                title: '',
                description: '<pre><span style="font-size: 10pt; font-family: arimo, helvetica, sans-serif;">Wstaw tu treść informacji</span></pre>',
                from_email: '',
                from_name: '',
                mailto: '',
                active: null,
            };
        },

        addSCAM() {
            this.addingNew = true;
            this.newSCAM = this.getEmptyForm();
        },
        cancelNewSCAM() {
            this.addingNew = false;
            this.newSCAM = this.getEmptyForm();
        },
        editSCAM(scamtest) {
            this.editingId = scamtest.id;
            this.isEditModalOpen = true;
            this.editedSCAM = { ...scamtest };
            this.editFormErrors = {
                from_email: '',
                from_name: ''
            };

        },
        async openWyniki(scamtest) {
            this.isWynikiModalOpen = true;
            this.wynikiSCAM = { ...scamtest };
            this.wyniki = [];
            this.wynikiLoading = true;

            try {
                const url = `/admin/phising/${scamtest.id}/wyniki`;
                const response = await axios.get(url);
                this.wyniki = response.data;

            } catch (error) {
                console.error('BŁĄD:', error);

            } finally {
                this.wynikiLoading = false;
            }
        },
        updateSCAM(scamtest) {
            this.editFormErrors = {
                from_email: '',
                from_name: ''
            };

            let hasErrors = false;

            if (!scamtest.from_email || !scamtest.from_email.trim()) {
                this.editFormErrors.from_email = 'Adres e-mail nadawcy jest wymagany.';
                hasErrors = true;
            }

            if (!scamtest.from_name || !scamtest.from_name.trim()) {
                this.editFormErrors.from_name = 'Nazwa nadawcy jest wymagana.';
                hasErrors = true;
            }

            if (hasErrors) {
                return;
            }

            const payload = {
                ...scamtest,
                description: typeof scamtest.description === 'object'
                    ? scamtest.description.value
                    : scamtest.description
            };

            this.$inertia.put(route('admin.phising.update', scamtest.id), payload, {
                onSuccess: () => {
                    const idx = this.scamtestLocal.findIndex(w => w.id === scamtest.id);

                    if (idx !== -1) {
                        this.scamtestLocal[idx] = { ...payload };
                    }

                    this.isEditModalOpen = false;
                }
            });
        },

        saveNewSCAM() {
            this.formErrors = {
                from_email: '',
                from_name: ''
            };

            let hasErrors = false;

            if (!this.newSCAM.from_email || !this.newSCAM.from_email.trim()) {
                this.formErrors.from_email = 'Adres e-mail nadawcy jest wymagany.';
                hasErrors = true;
            }

            if (!this.newSCAM.from_name || !this.newSCAM.from_name.trim()) {
                this.formErrors.from_name = 'Nazwa nadawcy jest wymagana.';
                hasErrors = true;
            }

            if (hasErrors) {
                return;
            }

            this.$inertia.post(route('admin.phising.dodaj'), this.newSCAM, {
                onSuccess: () => {
                    this.newSCAM = this.getEmptyForm();
                    this.formErrors = {
                        from_email: '',
                        from_name: ''
                    };
                    this.isModalOpen = false;
                    this.scamtestLocal = this.scamtest.map(t => ({ ...t }));
                }
            });
        },

        sendtest(scamtest) {
            Toast.fire({
                toast: false,
                icon: 'question',
                title: 'Wysyłanie testowe',
                html: `
					<div style="text-align: center;">
						<p style="margin-bottom: 10px;">
							Czy chcesz wysłać to ogłoszenie
							<strong>na swój adres e-mail?</strong>
						</p>

						<div style="
							background: #f8f9fa;
							padding: 10px;
							border-radius: 5px;
							text-align: left;
							margin-top: 10px;
						">
							<strong>${scamtest.title}</strong>
						</div>
					</div>
				`,
                showDenyButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Tak, wyślij',
                denyButtonText: 'Anuluj',
                timer: false,
                position: 'center'
            }).then((result) => {

                if (!result.isConfirmed) {
                    return;
                }

                this.$inertia.post(
                    route('admin.phising.send-test-mail', scamtest.id),
                    {},
                    {
                        preserveScroll: true,

                        onSuccess: () => {
                            Toast.fire({
                                toast: true,
                                icon: 'success',
                                title: 'Wysłano',
                                html: 'Wiadomość została wysłana na Twój adres e-mail.',
                                position: 'top-end',
                                timer: 4000,
                                showConfirmButton: false
                            });
                        },

                        onError: () => {
                            Toast.fire({
                                toast: true,
                                icon: 'error',
                                title: 'Błąd wysyłania',
                                html: 'Nie udało się wysłać wiadomości.',
                                position: 'top-end',
                                timer: 4000,
                                showConfirmButton: false
                            });
                        }
                    }
                );
            });
        },

        sendSCAM(scamtest) {
            this.wynikiSCAM = { ...scamtest };
            this.selectedUsers = [];
            this.selectAllUsers = false;
            this.isSendUsersModalOpen = true;
        },

        deleteSCAM(id) {
            Toast.fire({
                toast: false,
                icon: 'warning',
                title: 'Usuwanie informacji',
                html: 'Czy na pewno chcesz usunąć wybraną informację?',
                showDenyButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Tak',
                denyButtonText: 'Nie',
                timer: false,
                position: 'center'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$inertia.delete(route('admin.phising.usun', id), {
                        onSuccess: () => {
                            this.scamtestLocal = this.scamtestLocal.filter(w => w.id !== id);
                        }
                    });
                }
            });
        },
        typeLabel(type) {
            return {
                1: 'Informacja',
                2: 'Nowe zagrożenie'
            }[type] || 'Informacja'
        },

        badgeClass(type) {
            return {
                1: 'bg-primary',
                2: 'bg-danger'
            }[type] || 'bg-primary'
        }

    }
};
</script>
<style>
.select-all-wrapper {
    display: flex;
    align-items: center;
}

.select-all-label {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 0;
    cursor: pointer;
    font-weight: 600;
}

.user-checkbox {
    appearance: none;
    -webkit-appearance: none;

    width: 20px !important;
    height: 20px !important;

    border: 2px solid #999;
    border-radius: 5px;

    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    margin: 0;
}

.user-checkbox:checked {
    background-color: #198754;
    border-color: #198754;
    position: relative;
}

.user-checkbox:checked::after {
    content: "✓";
    color: white;
    font-size: 19px;
    font-weight: bold;

    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -55%);
}
</style>